module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron bg-transparent text-center margin-none"
  }, [_c('h1', [_vm._v("帮助文档")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.msg))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43ae5f48"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/Help.vue
// module id = 85
// module chunks = 0